import { Box, Button, Fade, Typography, useTheme } from "@mui/material";
import TotalChart from "../TotalChart";
import useChartOrderContainer from "./useChartOrderContainer";
import useDeviceType from "../../../global/Hooks/useDeviceType";
import TitleChart from "../components/TitleChart";
import useCheckDisplayChart from "../components/useCheckDisplayChart";
import { Filter1, Filter2 } from "@mui/icons-material";
import { FilterIcon } from "lucide-react";
import { useState } from "react";
import ChartRenderer from "./ChartRenderer";
import TabChartFilter from "../components/TabChartFilter";
import FilterHandler from "../components/FilterHandler";
import Filter from "./Filter";
function ProductionPlateChart() {
  const theme = useTheme().palette.mode;

  const {
    dataLineChart,
    chartFilter,
    activeFilterType,
    changeActiveFilterType,
    total,
    designerFiled,
    setDesignerFiled,
    customerFieldValue,
    setCustomerFieldValue,
    tabHandler,
    year,
    setYear,
    month,
    setMonth,
    day,
    setDay,
    KlischeType,
    setKlischeType,
    KilscheThicknes,
    setKilscheThicknes,
  } = useChartOrderContainer();
  const deviceType = useDeviceType();

  /* -------------------------------- Accrdion -------------------------------- */
  const chartKey = "productionPlateChart";
  const { displayChart } = useCheckDisplayChart(chartKey);
  const [filter, setFilter] = useState(false);
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };

  return (
    <>
      {displayChart ? (
        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: 2,
              marginBottom: "4px",
              flexWrap: "nowrap",
              overflowX: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                padding: "0.5rem",
              }}
            >
              <Button
                onClick={() => changeActiveFilterType(1)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 1
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                برحسب ابعاد پلیت
              </Button>
              <Button
                onClick={() => changeActiveFilterType(2)}
                sx={{
                  color: theme === "dark" ? "#FFF" : "#262D39",
                  borderBottom:
                    activeFilterType === 2
                      ? "2px solid rgba(30, 106, 253, 1)"
                      : "",
                }}
              >
                برحسب ابعاد سفارش
              </Button>
            </Box>
            <Box
              sx={{
                flexGrow: 1,
                width: "25%",
                display: "flex",
                justifyContent: "flex-start",
                minWidth: 200,
              }}
            >
              <TitleChart label={"تناسب نوع کلیشه"} chartKey={chartKey} />
            </Box>
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: "8px",
                }}
              >
                <TabChartFilter
                  chartFilter={chartFilter}
                  tabHandler={tabHandler}
                  name="Production"
                />
              </Box>
              <Box sx={{ placeSelf: "end" }}>
                <FilterHandler filter={filter} setFilter={setFilter} />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              display: "block",
              width: "100%",
              padding: "0.5rem",
              justifyContent: "space-between",
              flexDirection: deviceType === "mobile" ? "column" : "row",
            }}
          >
            <Box
              sx={{
                display: "flex",
                marginBottom: { md: "0", xs: "0.8rem" },
                flexWrap: "wrap",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "4px",
                  marginLeft: "auto",
                  marginRight: "-10px",
                }}
              ></Box>
            </Box>

            {filter && (
              <Fade in={filter} timeout={300}>
                <Box
                  sx={{
                    display: "flex",
                    marginTop: "12px",
                    marginBottom: "8px",
                    padding: "8px",
                    backgroundColor: theme == "light" ? "#E6F1FF" : "#161B25",
                  }}
                >
                  <Filter
                    customerFieldValue={customerFieldValue}
                    designerFiled={designerFiled}
                    setFieldValue={setCustomerFieldValue}
                    setDesignerFiled={setDesignerFiled}
                    chartFilter={chartFilter}
                    year={year}
                    setYear={setYear}
                    month={month}
                    setMonth={setMonth}
                    day={day}
                    setDay={setDay}
                    KlischeType={KlischeType}
                    KilscheThicknes={KilscheThicknes}
                    setKilscheThicknes={setKilscheThicknes}
                  />
                </Box>
              </Fade>
            )}
          </Box>
          <ChartRenderer data={dataLineChart} totalRecord={total} />
          <Box display={"flex"}>
            <Typography color="#3592FB">
              جمع کل: {total.map((item) => toPersianDigits(item.count))}
            </Typography>
          </Box>
        </>
      ) : (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TitleChart label={"تناسب نوع کلیشه"} chartKey={chartKey} />
        </Box>
      )}
    </>
  );
}

export default ProductionPlateChart;
